module.exports = __webpack_public_path__ + "img/BT_send_big.57429400.svg";